import React from 'react';
import { useConfirmationModalStore } from '../stores';
import Modal from '../layouts/app/content/controls/Modal';

// Глобальная модалка подтверждения опасных действий (новая верстка).
// Рендерится вне AppLayout, поэтому оборачиваем в .app-shell для scoped-стилей.
function ModalConfirmation() {
    const { isOpen, content, close, confirm, confirmText } = useConfirmationModalStore();

    if (!isOpen) return null;

    const footer = (
        <>
            <button type="button" className="btn btn-ghost" onClick={close}>Отмена</button>
            <button type="button" className="btn btn-danger" onClick={confirm}>{confirmText || 'Удалить'}</button>
        </>
    );

    return (
        <div className="app-shell">
            <Modal open title="Подтвердите действие" onClose={close} size="sm" footer={footer}>
                <div className="confirm-msg">{content}</div>
            </Modal>
        </div>
    );
}

export default ModalConfirmation;
